/* eslint-disable import/no-mutable-exports */
import { App } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import type { NotificationInstance } from 'antd/es/notification/interface';

let message: MessageInstance;
let notification: NotificationInstance;
let modal: Omit<ModalStaticFunctions, 'warn'>;

// ref: https://ant.design/components/app#global-scene-redux-scene
/**
 * A hook to get the static function of `App` component.
 * Ensables Usage of `message`, `modal`, `notification` outside of React components.
 * Mount the component in the root of the application before using the static functions.
 */
function AntAppUtil() {
  const staticFunction = App.useApp();
  message = staticFunction.message;
  modal = staticFunction.modal;
  notification = staticFunction.notification;
  return null;
}

export {
  AntAppUtil,
  message,
  modal,
  notification,
};
